module.exports = __webpack_public_path__ + "static/img/m_role.4722cb0.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/kc/m_role.png
// module id = TZ41
// module chunks = 7